import { useAuth0 } from '@auth0/auth0-react';
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import AllowanceUpdateForm from "../components/Allowance/AllowanceUpdateForm";
import ErrorPage from "./ErrorPage";
import DraggableProfilePanel from '../components/common/DraggableProfilePanel';

function Allowance () {
    const {  isAuthenticated } = useAuth0();
    return(
        isAuthenticated ? 
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                    <Header isVisible={true} buttonsVisible={true}/>
                </div>
                <div className="content-class">
                    <DraggableProfilePanel/>
                    <AllowanceUpdateForm></AllowanceUpdateForm>
                </div>
                <div className="footer-class">
                    <Footer />
                </div>
            </div>
        </div>
        </> 
         : <ErrorPage/>
    )
}

export default Allowance;